import { profilingWizardApi } from 'api';
import { ProfilingWizardStatusResponse } from 'pco-product-service-internal-consumer';

export const getProfilingWizardStatus = async (brUid: string): Promise<ProfilingWizardStatusResponse> =>
  await profilingWizardApi.getProfilingWizardStatus({ brUid });
